import { post, userpost } from "../../services";
import {
  ADD_NEW_BOOKING,
  ADD_NEW_FACILITY,
  ADD_NEW_HIGHLIGHT,
  ADD_NEW_USER,
  ADD_NEW_USER_BULK,
  CREATE_ADVERTISEMENT,
  CREATE_GROUP,
  LIST_ALL_ADS,
  LIST_ALL_BOOKINGS,
  LIST_ALL_FACILITIES,
  LIST_ALL_GROUPS,
  LIST_ALL_HIGHLIGHTS,
  LIST_ALL_USER_GAMES,
  LIST_ALL_USERS,
  LIST_USER_CARDS_QUERY,
  UPDATE_GROUP,
} from "../../graphql";
import {
  RESET_ADS,
  RESET_ALL_BOOKINGS,
  RESET_ALL_FACILITIES_DATA,
  RESET_ALL_HIGHLIGHTS_DATA,
  RESET_ALL_ROOMS_LIST,
  RESET_USER_GAMES,
  RESET_USER_GROUPS,
  SAVE_ADS,
  SAVE_ALL_BOOKINGS,
  SAVE_ALL_FACILITIES,
  SAVE_ALL_HIGHLIGHTS,
  SAVE_ALL_ROOMS_LIST,
  SAVE_USER_GAMES,
  SAVE_USER_GROUPS,
  TOGGLE_LOADING,
} from "../types";

export const addNewHighlight = (requestData) => {
  return async (dispatch) => {
    dispatch({ type: TOGGLE_LOADING, payload: true });

    let apiResponse = await post("", {
      query: ADD_NEW_HIGHLIGHT,
      variables: requestData,
    });

    if (apiResponse.data.customStatus) {
      dispatch(resetAllHighlightsData());
      dispatch(listAllHighlights());
      return true;
    }
    dispatch({ type: TOGGLE_LOADING, payload: false });
  };
};

export const listAllHighlights = (requestData) => {
  return async (dispatch, getState) => {
    dispatch({ type: TOGGLE_LOADING, payload: true });

    const {
      highlights: { pageSize, pageNumber, list },
    } = getState().admin;

    let apiResponse = await post("", {
      query: LIST_ALL_HIGHLIGHTS,
      variables: {
        pageSize: pageSize,
        pageNumber: pageNumber,
        ...requestData,
      },
    });

    if (apiResponse.data.customStatus) {
      let {
        list_all_highlights: { data, hasMore },
      } = apiResponse.data.data;

      let updatedList = [...list, ...data];

      dispatch({
        type: SAVE_ALL_HIGHLIGHTS,
        payload: {
          list: updatedList,
          showViewMore: hasMore,
          pageNumber: pageNumber + 1,
        },
      });
    }
    dispatch({ type: TOGGLE_LOADING, payload: false });
  };
};

export const resetAllHighlightsData = () => {
  return async (dispatch) => {
    dispatch({ type: RESET_ALL_HIGHLIGHTS_DATA });
  };
};

export const addNewFacility = (requestData) => {
  return async (dispatch) => {
    dispatch({ type: TOGGLE_LOADING, payload: true });

    let apiResponse = await post("", {
      query: ADD_NEW_FACILITY,
      variables: requestData,
    });

    if (apiResponse.data.customStatus) {
      dispatch(resetAllFacilitiesData());
      dispatch(listAllFacilities());
      return true;
    }
    dispatch({ type: TOGGLE_LOADING, payload: false });
  };
};

export const listAllFacilities = (requestData) => {
  return async (dispatch, getState) => {
    dispatch({ type: TOGGLE_LOADING, payload: true });

    const {
      facilities: { pageSize, pageNumber, list },
    } = getState().admin;

    let apiResponse = await post("", {
      query: LIST_ALL_FACILITIES,
      variables: {
        pageSize: pageSize,
        pageNumber: pageNumber,
        ...requestData,
      },
    });

    if (apiResponse.data.customStatus) {
      let {
        list_all_facilities: { data, hasMore },
      } = apiResponse.data.data;

      let updatedList = [...list, ...data];

      dispatch({
        type: SAVE_ALL_FACILITIES,
        payload: {
          list: updatedList,
          showViewMore: hasMore,
          pageNumber: pageNumber + 1,
        },
      });
    }
    dispatch({ type: TOGGLE_LOADING, payload: false });
  };
};

export const resetAllFacilitiesData = () => {
  return async (dispatch) => {
    dispatch({ type: RESET_ALL_FACILITIES_DATA });
  };
};

export const addNewBooking = (requestData) => {
  return async (dispatch) => {
    dispatch({ type: TOGGLE_LOADING, payload: true });

    let apiResponse = await post("", {
      query: ADD_NEW_BOOKING,
      variables: requestData,
    });

    if (apiResponse.data.customStatus) {
      dispatch(resetAllBookingsData());
      dispatch(listAllBookings());
      return true;
    }
    dispatch({ type: TOGGLE_LOADING, payload: false });
  };
};

export const listAllBookings = (requestData) => {
  return async (dispatch, getState) => {
    dispatch({ type: TOGGLE_LOADING, payload: true });
    const {
      bookings: { pageSize, pageNumber, list },
    } = getState().admin;

    let apiResponse = await post("", {
      query: LIST_ALL_BOOKINGS,
      variables: {
        pageSize: pageSize,
        pageNumber: pageNumber,
        ...requestData,
      },
    });

    if (apiResponse.data.customStatus) {
      let {
        list_all_games: { data, hasMore },
      } = apiResponse.data.data;
      let updatedList = [...list, ...data];

      dispatch({
        type: SAVE_ALL_BOOKINGS,
        payload: {
          list: updatedList,
          showViewMore: hasMore,
          pageNumber: pageNumber + 1,
        },
      });
    }
    dispatch({ type: TOGGLE_LOADING, payload: false });
  };
};

export const resetAllBookingsData = () => {
  return async (dispatch) => {
    dispatch({ type: RESET_ALL_BOOKINGS });
  };
};

export const addNewRoom = (requestData) => {
  return async (dispatch) => {
    dispatch({ type: TOGGLE_LOADING, payload: true });

    let apiResponse = await post("", {
      query: ADD_NEW_USER,
      variables: requestData,
    });

    if (apiResponse.data.customStatus) {
      dispatch(resetAllRoomsList());
      dispatch(listAllRooms());
      return true;
    }
    dispatch({ type: TOGGLE_LOADING, payload: false });
  };
};

export const addBulkRooms = (data) => {
  return async (dispatch) => {
    dispatch({ type: TOGGLE_LOADING, payload: true });
    console.log(data, "dataaa");

    let apiResponse = await post("", {
      query: ADD_NEW_USER_BULK,
      variables: {
        users: data.users, // array of user objects
        sendEmail: data.sendEmail, // boolean value
      },
    });

    if (apiResponse.data.customStatus) {
      dispatch(resetAllRoomsList());
      dispatch(listAllRooms());
      return true;
    }
    dispatch({ type: TOGGLE_LOADING, payload: false });
  };
};

export const listAllRooms = (requestData) => {
  return async (dispatch, getState) => {
    dispatch({ type: TOGGLE_LOADING, payload: true });
    const {
      rooms: { pageSize, pageNumber, list },
    } = getState().admin;

    let apiResponse = await post("", {
      query: LIST_ALL_USERS,
      variables: {
        pageSize: pageSize,
        pageNumber: pageNumber,
        ...requestData,
      },
    });

    if (apiResponse.data.customStatus) {
      let {
        list_all_users: { data, hasMore },
      } = apiResponse.data.data;
      let updatedList = [...list, ...data];

      dispatch({
        type: SAVE_ALL_ROOMS_LIST,
        payload: {
          list: updatedList,
          showViewMore: hasMore,
          pageNumber: pageNumber + 1,
        },
      });
    }
    dispatch({ type: TOGGLE_LOADING, payload: false });
  };
};

export const resetAllRoomsList = () => {
  return async (dispatch) => {
    dispatch({ type: RESET_ALL_ROOMS_LIST });
  };
};

export const listAllUserGames = (userId, requestData = {}) => {
  return async (dispatch, getState) => {
    dispatch({ type: TOGGLE_LOADING, payload: true });

    try {
      const adminState = getState().admin || {};
      const userGames = adminState.userGames || {
        list: [],
        pageSize: 10,
        pageNumber: 1,
      };
      const { list, pageSize, pageNumber } = userGames;

      const apiResponse = await userpost("", {
        query: LIST_ALL_USER_GAMES,
        variables: {
          pageSize,
          pageNumber,
          userId,
          ...requestData,
        },
      });

      const gamesData = apiResponse?.data?.data?.list_all_user_games;

      if (apiResponse.data?.customStatus && gamesData) {
        const { data, hasMore } = gamesData;

        dispatch({
          type: SAVE_USER_GAMES,
          payload: {
            list: [...list, ...data],
            showViewMore: hasMore,
            pageNumber: pageNumber + 1,
          },
        });
      }
    } catch (error) {
      console.error("Error fetching user games:", error);
    } finally {
      dispatch({ type: TOGGLE_LOADING, payload: false });
    }
  };
};

export const resetUserGames = () => ({
  type: RESET_USER_GAMES,
});

export const fetchAllGroups = () => {
  return async (dispatch, getState) => {
    dispatch({ type: TOGGLE_LOADING, payload: true });
    dispatch({ type: RESET_USER_GROUPS });

    try {
      const adminState = getState().admin || {};
      const pageNumber = adminState.userGroups.pageNumber || 1;

      const apiResponse = await post("", {
        query: LIST_ALL_GROUPS,
        variables: {
          pageSize: 10,
          pageNumber: pageNumber,
        },
      });

      console.log(apiResponse, " api responseee");

      const groupsData = apiResponse?.data?.data?.list_all_groups;

      if (apiResponse.data?.customStatus && groupsData) {
        const { data, hasMore } = groupsData;

        dispatch({
          type: SAVE_USER_GROUPS,
          payload: {
            list: data,
            showViewMore: hasMore,
            pageNumber: pageNumber + 1,
          },
        });
      }
    } catch (error) {
      console.error("Error fetching user games:", error);
    } finally {
      dispatch({ type: TOGGLE_LOADING, payload: false });
    }
  };
};

export const addGroup = (data) => {
  const finalData = {
    name: String(data.name).trim(),
    status: data.status,
    start_time: data.start_time,
    users: data.users,
  };

  return async (dispatch) => {
    dispatch({ type: TOGGLE_LOADING, payload: true });
    try {
      const apiResponse = await post("", {
        query: CREATE_GROUP,
        variables: {
          args: finalData,
        },
      });

      if (apiResponse.data?.data?.create_group?.message) {
        dispatch(fetchAllGroups());
        dispatch({ type: TOGGLE_LOADING, payload: false });
      }
    } catch (e) {
      console.error("Error adding user groups:", e);
    }
  };
};

export const editGroup = ({ groupId, name, status, users }) => {
  const finalData = {
    group_id: groupId,
    ...(name && { name }),
    ...(status && { status }),
    ...(users &&
      users.length > 0 && {
        users: users.map((u) => u._id),
      }),
  };

  console.log(finalData, "finaldata");

  return async (dispatch) => {
    dispatch({ type: TOGGLE_LOADING, payload: true });
    try {
      let apiResponse = await post("", {
        query: UPDATE_GROUP,
        variables: {
          args: finalData,
        },
      });

      if (apiResponse?.data?.data?.edit_group?.message) {
        dispatch(fetchAllGroups());
        dispatch({ type: TOGGLE_LOADING, payload: false });
      }
    } catch (e) {
      console.error("Error adding user groups:", e);
    }
  };
};

export const resetUserGroups = () => ({
  type: RESET_USER_GROUPS,
});

export const addAds = ({ media_type, media_url, name }) => {
  return async (dispatch) => {
    dispatch({ type: TOGGLE_LOADING, payload: true });
    try {
      let apiResponse = await post("", {
        query: CREATE_ADVERTISEMENT,
        variables: {
          args: {
            media_type,
            media_url,
            name,
          },
        },
      });
      if (apiResponse?.data?.data?.create_advertisement?.success) {
        dispatch(fetchAllAds());
        dispatch({ type: TOGGLE_LOADING, payload: false });
      }
    } catch (e) {
      console.error("Error adding user groups:", e);
    }
  };
};

export const fetchAllAds = () => {
  return async (dispatch, getState) => {
    dispatch({ type: TOGGLE_LOADING, payload: true });
    dispatch({ type: RESET_ADS });

    try {
      const adminState = getState().admin || {};
      const pageNumber = adminState.ads.pageNumber || 1;

      const apiResponse = await post("", {
        query: LIST_ALL_ADS,
      });

      console.log(apiResponse.data?.data?.list_all_ads?.success);

      if (apiResponse.data?.data?.list_all_ads?.success) {
        const advertisements =
          apiResponse.data?.data?.list_all_ads?.advertisements;

        dispatch({
          type: SAVE_ADS,
          payload: {
            list: advertisements,
            pageNumber: pageNumber + 1,
          },
        });
      }
    } catch (error) {
      console.error("Error fetching adds:", error);
    } finally {
      dispatch({ type: TOGGLE_LOADING, payload: false });
    }
  };
};

export const resetAds = () => ({
  type: RESET_ADS,
});
